<template>
  <div
    class="dashboard"
    data-intro="Информационная панель с данными организации"
  >
    <v-row no-gutters>
      <v-col sm="4" v-if="!isAdministrator">
        <OrganizationInfo
          :contracts="contracts"
          :creditDays="organizationSettings.creditDays"
        />
      </v-col>
      <v-col sm="4">
        <ManagerInfo
          :managerInfo="serviceManager"
          :icon="icons.faceAgent"
          :isServiceManager="true"
          title="Клиентская служба"
        />
      </v-col>
      <v-col sm="4">
        <ManagerInfo
          :managerInfo="deliveryManager"
          :icon="icons.ambulance"
          title="Экспедиционный отдел"
        />
      </v-col>
      <v-col
        sm="4"
        v-if="
          this.user.settings &&
          (this.user.settings.usePharmacy == true ||
            this.user.settings.useDietarySupplement == true ||
            this.user.settings.useMedicalProducts == true)
        "
      >
        <ManagerInfo
          :managerInfo="pharmacyManager"
          :icon="icons.pharmacy"
          title='Менеджер "аптека"'
        />
      </v-col>
      <v-col sm="4" v-if="this.user.settings && this.user.settings.useCosmetic">
        <ManagerInfo
          :managerInfo="cosmeticManager"
          :icon="icons.spotlightBeam"
          title='Менеджер "косметика"'
        />
      </v-col>
      <v-col
        sm="4"
        v-if="this.user.settings && this.user.settings.useMedicalEquipment"
      >
        <ManagerInfo
          :managerInfo="medicalEquipmentManager"
          :icon="icons.medicalBag"
          title='Менеджер "медтехника"'
        />
      </v-col>
      <v-col sm="4" v-if="this.user.settings && this.user.settings.useOptics">
        <ManagerInfo
          :managerInfo="opticsManager"
          :icon="icons.glasses"
          title='Менеджер "оптика"'
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";

const OrganizationInfo = () =>
  import("@/components/Dashboard/OrganizationInfo");
const ManagerInfo = () => import("@/components/Dashboard/ManagerInfo");

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    organizationSettings: {
      type: Object,
      required: true,
    },
    contracts: {
      type: Array,
      required: true,
    },
  },
  components: {
    OrganizationInfo,
    ManagerInfo,
  },
  computed: {
    cosmeticManager() {
      // return Object.keys(this.organizationSettings)
      //   .filter(propertyName => {
      //     return propertyName.indexOf("cosmetic") === 0;
      //   })
      //   .reduce((obj, key) => {
      //     return {
      //       ...obj,
      //       [key.replace("cosmetic", "")]: this.organizationSettings[key]
      //     };
      //   }, {});
      return {
        Manager: "Сушко Ольга Васильевна",
        ManagerPhone: "(017) 543 00 13, (017) 543 00 14",
        ManagerEmail: "sales@interfarmax.by",
      };
    },
    medicalEquipmentManager() {
      // return Object.keys(this.organizationSettings)
      //   .filter(propertyName => {
      //     return propertyName.indexOf("medicalEquipment") === 0;
      //   })
      //   .reduce((obj, key) => {
      //     return {
      //       ...obj,
      //       [key.replace("medicalEquipment", "")]: this.organizationSettings[
      //         key
      //       ]
      //     };
      //   }, {});
      return {
        Manager: "Эрм Наталья Анатольевна",
        ManagerPhone: "(017) 543 00 15",
        ManagerEmail: "nerm@interfarmax.by",
      };
    },
    opticsManager() {
      // return Object.keys(this.organizationSettings)
      //   .filter(propertyName => {
      //     return propertyName.indexOf("optics") === 0;
      //   })
      //   .reduce((obj, key) => {
      //     return {
      //       ...obj,
      //       [key.replace("optics", "")]: this.organizationSettings[key]
      //     };
      //   }, {});
      return {
        Manager: "Номеровский Владимир Витальевич",
        ManagerPhone: "(017) 543 00 76, (029) 640 3 640",
        ManagerEmail: "vnomerovsky@interfarmax.by",
      };
    },
    pharmacyManager() {
      return Object.keys(this.organizationSettings)
        .filter((propertyName) => {
          return propertyName.indexOf("pharmacy") === 0;
        })
        .reduce((obj, key) => {
          return {
            ...obj,
            [key.replace("pharmacy", "")]: this.organizationSettings[key],
          };
        }, {});
    },
    serviceManager() {
      return {
        ManagerPhone: "(017) 543 00 69, (044) 729 70 99",
        ManagerEmail: "pretenzii@interfarmax.by",
      };
    },
    deliveryManager() {
      return {
        ManagerPhone: "(017) 543 00 68",
        ManagerEmail: "expedition@interfarmax.by",
      };
    },
    isAdministrator() {
      return this.user.userRoles != null
        ? this.user.userRoles.includes("Administrator")
        : null;
    },
  },
  methods: {
    ...mapActions({}),
  },
  data: () => ({
    icons: {
      ambulance: Icon.ambulance,
      faceAgent: Icon.faceAgent,
      glasses: Icon.glasses,
      medicalBag: Icon.medicalBag,
      pharmacy: Icon.pharmacy,
      spotlightBeam: Icon.spotlightBeam,
    },
  }),
  mounted: async function () {},
};
</script>
